export enum DevicesApiRoutes {
  SubmitExamData = '/{organizationCoreId}/devices/{locationCoreId}/submit',
  GetOrganizationLocations = '/devices/organizationLocations',
  GetAppointment = '/devices/{locationCoreId}/appointments',
  GetExamData = '/{organizationCoreId}/devices/{locationCoreId}/exams',
}

export enum PMSSettingsApiRoutes {
  PatientStatement = '/settings/patient-statement',
  EditableFields = '/v3/{organizationId}/settings/editable-fields',
  LocationTaxes = '/settings/location/{locationId}/taxes',
  Locations = '/settings/location',
  LocationClx = '/settings/location/{locationId}/clx',
  ListSettings = '/settings/list/names',
  ListSettingsPMS = '/v3/{organizationId}/settings/list/names',
  SearchSettings = '/settings/list/search',
  SearchSettingsPMS = '/v3/{organizationId}/settings/list/search',
  UpdateListSettings = '/settings/list',
  UpdateListSettingsPMS = '/v3/{organizationId}/settings/list',
  //ReferringProvider = '/settings/list/referring-provider/##referringProviderId',
  UpdateReferringProvider = '/settings/list/referring-provider/##referringProviderId',
  CreateReferringProvider = '/settings/list/referring-provider',
  Insurance = '/Settings/Insurances/Search',
  InsurancePlanDetails = '/Settings/Insurances/',
  InsuranceCmsDefault = '/ManagementSettings/Insurances/Cms-Default/Search',
  LocationName = '/miscellaneous/locations',
  InsuranceName = '/miscellaneous/insurances',
  ClaimBoxName = '/miscellaneous/claim-boxes',
  DeleteInsuranceCmsDefault = '/ManagementSettings/Insurances/Cms-Default',
  ConfigurationBox17 = '/ManagementSettings/Insurances/Cms-Default/Box-17',
  ConfigurationBox27 = '/ManagementSettings/Insurances/Cms-Default/Box-27',
  ConfigurationBox29 = '/ManagementSettings/Insurances/Cms-Default/Box-29',
  ConfigurationBox23 = '/ManagementSettings/Insurances/Cms-Default/Box-23',
  ConfigurationBox31 = '/ManagementSettings/Insurances/Cms-Default/Box-31',
  ConfigurationBox32 = '/ManagementSettings/Insurances/Cms-Default/Box-32',
  ConfigurationBox33 = '/ManagementSettings/Insurances/Cms-Default/Box-33',
  ConfigurationBox11d = '/ManagementSettings/Insurances/Cms-Default/Box-11d',
  CptCodes = '/miscellaneous/cpt-codes',
  GroupProviders = '/miscellaneous/group-providers',
  RtLtDefaultSearch = '/ManagementSettings/Insurances/Management/Modifier-rules/Rt-lt/Search',
  RtLtDefault = '/ManagementSettings/Insurances/Management/Modifier-rules/Rt-lt',
  SpectacleLenses = '/miscellaneous/spectacle-lenses',
  AddOns = '/miscellaneous/add-ons',
  ModiferRulesSearch = '/ManagementSettings/Insurances/Management/Modifier-rules/Search',
  ModifierRules = '/ManagementSettings/Insurances/Management/Modifier-rules',
  Modifiers = '/miscellaneous/modifiers',
  PlaceOfService = '/miscellaneous/place-of-services',
  InsuranceClassifications = '/miscellaneous/insurance-classifications',
  UpdatePlanDetails = '/settings/insurances/{insuranceId}/plans',
  InsurancePlanNames = '/PlanSettings/Insurances/{insuranceId}/Plans',
  InsurancePlanOptions = '/PlanSettings/Insurances/{insuranceId}',
  FeeSchedulesServices = '/settings/insurances/{insuranceId}/fee-schedules/professional-services/search',
  UpdateFeeSchedulesServices = '/FeeScheduleSettings/Insurances/{insuranceId}/Professional-Services',
  SplitCode = '/ManagementSettings/Insurances/Split-Codes',
  SplitCodeSearch = '/ManagementSettings/Insurances/Split-Codes/Search',
  Organization = '/settings/organization',
  DiscountSpectaclesLens = '/settings/list/discount-reason/discount-types/##discountTypeId/spectacle-lenses',
  DiscountType = '/settings/list/discount-reason/discount-types',
  DefaultDiscountType = '/settings/list/discount-reason/default-discount-types',
  ProfessionalServices = '/miscellaneous/professional-services',
  Discount = '/settings/list/discount-reason',
  DiscountById = '/settings/list/discount-reason/##discountTypeId',
  PrescriptionUsage = '/settings/list/optical-prescription-usage',
  PrescriptionUsageById = '/settings/list/optical-prescription-usage/##opticalPrescriptionUsageId',
  FeeSchedulesSearch = '/FeeScheduleSettings/Insurances/{insuranceId}/Professional-Services/Search',
  CloseableDays = '/DailyCloseout/locations/{locationId}/daily-closeout/days',
  DayPaymentSummary = '/DailyCloseout/locations/{locationId}/daily-closeout/payment-summary',
  DayBankSummary = '/DailyCloseout/locations/{locationId}/daily-closeout/bank-summary',
  DayRefundSummary = '/DailyCloseout/locations/{locationId}/daily-closeout/refund-summary',
  DaySalesSummary = '/DailyCloseout/locations/{locationId}/daily-closeout/sales-summary',
  DayNotes = '/DailyCloseout/locations/{locationId}/daily-closeout/notes',
  SaveDay = '/DailyCloseout/{locationId}/daily-closeout',
  CloseDay = '/DailyCloseout/{locationId}/daily-closeout/close',
  Print = '/DailyCloseout/locations/{locationId}/daily-closeout/print-summary',
}
